/**
 * ELONGÉ — Core sitewide behavior: header scroll state, mega menu,
 * mobile menu, accordions, announcement bar rotation, quick add/view modal.
 */
(function () {
  'use strict';

  /* ---------------- Header scroll state ---------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var lastScroll = 0;
    var sticky = header.getAttribute('data-sticky') === 'true';
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (sticky) {
        header.classList.toggle('header-hidden', y > lastScroll && y > 200);
      }
      lastScroll = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Mega menu (desktop hover + keyboard) ---------------- */
  document.querySelectorAll('[data-nav-item]').forEach(function (item) {
    var link = item.querySelector('.site-header__link');
    var openItem = function () {
      document.querySelectorAll('[data-nav-item].is-open').forEach(function (el) { if (el !== item) el.classList.remove('is-open'); });
      item.classList.add('is-open');
      if (link) link.setAttribute('aria-expanded', 'true');
    };
    var closeItem = function () {
      item.classList.remove('is-open');
      if (link) link.setAttribute('aria-expanded', 'false');
    };
    item.addEventListener('mouseenter', openItem);
    item.addEventListener('mouseleave', closeItem);
    item.addEventListener('focusin', openItem);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) closeItem();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-nav-item].is-open').forEach(function (el) { el.classList.remove('is-open'); });
    }
  });

  /* ---------------- Mobile menu ---------------- */
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileClose = document.querySelector('[data-mobile-menu-close]');
  var mobileBackdrop = document.querySelector('[data-mobile-menu-backdrop]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileBackdrop) mobileBackdrop.classList.add('is-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileBackdrop) mobileBackdrop.classList.remove('is-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileMenu);

  document.querySelectorAll('[data-mobile-submenu-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.mobile-menu__item');
      var submenu = item.querySelector('[data-mobile-submenu]');
      if (!submenu) return;
      submenu.classList.toggle('is-open');
    });
  });

  /* ---------------- Announcement bar rotation ---------------- */
  var announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar) {
    var slides = announcementBar.querySelectorAll('.announcement-bar__slide');
    var current = 0;
    var interval = parseInt(announcementBar.getAttribute('data-interval'), 10) || 5000;
    var autoplay = announcementBar.getAttribute('data-autoplay') === 'true';
    var timer;

    function showSlide(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      current = index;
    }
    function next() { showSlide((current + 1) % slides.length); }
    function prev() { showSlide((current - 1 + slides.length) % slides.length); }

    var nextBtn = announcementBar.querySelector('[data-announcement-next]');
    var prevBtn = announcementBar.querySelector('[data-announcement-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetTimer(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetTimer(); });

    function resetTimer() {
      if (timer) clearInterval(timer);
      if (autoplay && slides.length > 1) timer = setInterval(next, interval);
    }
    resetTimer();
  }

  /* ---------------- Accordions (FAQ + product accordions) ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('.accordion__item');
    var panel = item.querySelector('[data-accordion-panel]');
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    if (expanded) {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      panel.addEventListener('transitionend', function handler() {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', handler);
      });
    }
  });

  /* ---------------- Quick add / quick view modal ---------------- */
  var quickAddModal = document.querySelector('[data-quick-add-modal]');
  var quickAddContent = document.querySelector('[data-quick-add-content]');
  var quickAddClose = document.querySelector('[data-quick-add-close]');

  function openQuickAdd(productUrl) {
    if (!quickAddModal || !quickAddContent) return;
    quickAddContent.innerHTML = '<div class="text-center" style="padding:60px;"></div>';
    quickAddModal.classList.add('is-open');
    quickAddModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetch(productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-add')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        quickAddContent.innerHTML = html;
        document.dispatchEvent(new CustomEvent('elonge:quick-add-loaded', { detail: { root: quickAddContent } }));
      })
      .catch(function (err) { console.error('[quick-add]', err); });
  }
  function closeQuickAdd() {
    if (!quickAddModal) return;
    quickAddModal.classList.remove('is-open');
    quickAddModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-quick-add-open]');
    if (opener) {
      e.preventDefault();
      openQuickAdd(opener.getAttribute('data-product-url'));
      return;
    }
    if (e.target.closest('[data-quick-add-close]') || e.target === quickAddModal) {
      closeQuickAdd();
    }
  });
  if (quickAddClose) quickAddClose.addEventListener('click', closeQuickAdd);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeQuickAdd();
  });

  /* Variant select + quantity handling inside the quick-add form */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-quick-add-option-selector]');
    if (!select) return;
    var form = select.closest('form');
    var variantsJson = form.parentElement.querySelector('[data-quick-add-variants]');
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson.textContent);
    var optionSelectors = form.querySelectorAll('[data-quick-add-option-selector]');
    var selectedOptions = Array.prototype.map.call(optionSelectors, function (s) { return s.value; });
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });
    if (match) {
      var input = form.querySelector('[data-quick-add-variant-id]');
      if (input) input.value = match.id;
      var submit = form.querySelector('[data-quick-add-submit]');
      if (submit) submit.disabled = !match.available;
    }
  });

  /* ---------------- Filter drawer (collection page) ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-drawer-toggle]')) {
      var fd = document.querySelector('[data-filter-drawer]');
      var fb = document.querySelector('[data-filter-drawer-backdrop]');
      if (fd) { fd.classList.add('is-open'); fd.setAttribute('aria-hidden', 'false'); }
      if (fb) fb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-filter-drawer-close]') || e.target.closest('[data-filter-drawer-backdrop]')) {
      var fd2 = document.querySelector('[data-filter-drawer]');
      var fb2 = document.querySelector('[data-filter-drawer-backdrop]');
      if (fd2) { fd2.classList.remove('is-open'); fd2.setAttribute('aria-hidden', 'true'); }
      if (fb2) fb2.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* Auto-submit sort select */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------------- Wishlist (localStorage-backed; app upgrade path documented in README) ---------------- */
  var WISHLIST_KEY = 'elonge:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(ids) { localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids)); }

  function refreshWishlistButtons() {
    var handles = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = handles.indexOf(handle) > -1;
      btn.setAttribute('aria-pressed', String(active));
      btn.innerHTML = '';
      btn.insertAdjacentHTML('afterbegin', '<svg class="icon" viewBox="0 0 24 24"' + (active ? ' fill="currentColor" stroke="none"' : '') + ' aria-hidden="true"><path d="M12 20.2s-7.6-4.5-9.8-9A5.2 5.2 0 0 1 12 6.6 5.2 5.2 0 0 1 21.8 11c-2.2 4.6-9.8 9.2-9.8 9.2Z"/></svg>');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var handles = getWishlist();
    var index = handles.indexOf(handle);
    if (index > -1) handles.splice(index, 1); else handles.push(handle);
    setWishlist(handles);
    refreshWishlistButtons();
    document.dispatchEvent(new CustomEvent('elonge:wishlist-changed', { detail: { handles: handles } }));
  });
  refreshWishlistButtons();
  window.ElongeWishlist = { get: getWishlist, set: setWishlist };
})();
